import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: [],
    fromPathName: '',
    wordCloudData: [],
    murmur: ''
  },
  mutations: {
    updateCount(state,num){
      state.count = num
    },
    // 存储路由路径的名字[解决路径参数大小写的问题]
    updateFromPathName(state,num){
      state.fromPathName = num
    },
    // 存储echarts数据
    updateWordCloudData(state, datas) {
      state.wordCloudData = datas
    }
  },
  actions: {
  },
  modules: {
  }
})